import React from 'react'

import { StyledGridItem } from './Grid.styled'

const GridItem: any = ({
  alignContent,
  alignItems,
  borderLeft,
  children,
  justifyContent,
  margin,
  minWidth,
  padding,
}) => (
  <StyledGridItem
    alignContent={alignContent}
    alignItems={alignItems}
    borderLeft={borderLeft}
    justifyContent={justifyContent}
    margin={margin}
    minWidth={minWidth}
    padding={padding}
  >
    {children}
  </StyledGridItem>
)

export default GridItem
